import { useBreadcrumbs } from '@/hooks/Breadcrumbs/useBreadcrumbs';
import { cn } from '@/lib/utils';
import resourceUrl from '@/util/makeUrl';
import clsx from 'clsx';
import Link from 'next/link';
import { Fragment, useMemo } from 'react';

export const ProductBreadcrumb = ({
  productDetails,
  breadcrumbsData,
}: {
  productDetails: any;
  breadcrumbsData: any;
}) => {
  if (!breadcrumbsData) {
    return null;
  }

  return (
    <Breadcrumbs
      breadcrumbsData={breadcrumbsData}
      currentProduct={productDetails.name
        .replace(/&#039;/g, "'")
        .replace(/&quot/g, '')
        .replace('&amp;', '&')}
    />
  );
};

const Breadcrumbs = ({
  currentProduct,
  breadcrumbsData,
}: {
  currentProduct?: string;
  className?: string;
  breadcrumbsData: any;
}) => {
  const talonProps = useBreadcrumbs({
    breadcrumbsData,
  });

  const { currentCategory, currentCategoryPath, normalizedData } = talonProps;

  const links = useMemo(() => {
    return normalizedData.map(({ text, path }) => {
      return (
        <Fragment key={text}>
          <Link
            className='  font-roboto-medium font-medium'
            href={resourceUrl(path)}
          >
            {text}
          </Link>
          <span>&nbsp;&gt;&nbsp;</span>
        </Fragment>
      );
    });
  }, [normalizedData]);

  // if (isLoading || hasError) {
  //   return <div className='hidden h-[26px] lg_block'></div>;
  // }

  const currentCategoryLink = currentProduct ? (
    normalizedData.length === 0 ? (
      <>
        <Link
          className='font-roboto-medium font-medium underline'
          href={resourceUrl(currentCategoryPath)}
        >
          {currentCategory}
        </Link>
        <span className='font-roboto-light font-light'>&nbsp;&gt;&nbsp;</span>
      </>
    ) : null
  ) : (
    <span className={cn('capitalize', 'font-roboto-light font-light text-black')}>{currentCategory}</span>
  );

  const currentProductNode = currentProduct ? (
    <Fragment>
      <span className={cn('capitalize', 'pr-3', 'font-roboto-light font-light text-black', 'relative', 'mr-2.5')}>
        {currentProduct}
      </span>
    </Fragment>
  ) : null;

  return (
    <div
      className={clsx(
        'px-3 py-5 lg_px-0 lg_pb-5 lg_pt-10',
        'text-[14px] leading-[20px] lg_text-[16px] lg_text-base lg_leading-[26px]',
        'mx-auto max-w-site',
      )}
    >
      <>
        <Link
          className={clsx('text-sm leading-none underline lg_text-base', 'font-roboto-medium font-medium')}
          href='/'
        >
          Home
        </Link>
        <span className='font-roboto-light font-light'>&nbsp;&gt;&nbsp;</span>
      </>
      {links}
      <span>{currentCategoryLink}</span>
      {currentProductNode}
    </div>
  );
};
